import { Component, Inject, OnInit } from '@angular/core';
import { IAccount } from 'app/store/models/account.model';
import { IReferralPartner } from 'app/store/models/franchisee.model';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openSnackbar } from 'app/store/actions/page.action';
import { TABLE_COMPONENT, TableComponent } from '../../../shared/ui/table/table.component';
import { FranchiseeService } from 'app/franchisee/franchisee.service';

@Component({
  selector: 'app-referral-partner-control',
  templateUrl: './referral-partner-control.component.html',
  styleUrls: ['./referral-partner-control.component.scss'],
})
export class ReferralPartnerControlComponent implements OnInit {
  public column: IAccount;
  public referralPartners: IReferralPartner[] = [];
  public franchiseeId: number;

  constructor(
    private store: Store<IReducers>,
    private franchiseeService: FranchiseeService,
    @Inject(TABLE_COMPONENT) private tableComponent: TableComponent,
  ) {}

  ngOnInit() {}

  get canAssign(): boolean {
    if (!this.franchiseeId) {
      return false;
    }
    // Direct attribution or inherited under a directly attributed manager/partner.
    return (
      Number(this.column.franchisee_id) === Number(this.franchiseeId) ||
      this.column.inherit_from_id != null
    );
  }

  getItems() {
    const items = (this.referralPartners || []).map(partner => ({
      label: partner.name,
      value: partner.id,
    }));
    return [{ label: 'None', value: '' }, ...items];
  }

  onPartnerSelect(partnerId: number | string) {
    if (!this.canAssign) {
      return;
    }

    const referralPartnerId =
      partnerId === '' || partnerId == null ? null : Number(partnerId);

    if (
      (referralPartnerId == null && !this.column.referral_partner_id) ||
      Number(referralPartnerId) === Number(this.column.referral_partner_id)
    ) {
      return;
    }

    this.franchiseeService
      .assignFranchiseeAccount(Number(this.franchiseeId), Number(this.column.account_id), {
        referral_partner_id: referralPartnerId,
      })
      .subscribe(
        () => {
          this.column.referral_partner_id = referralPartnerId;
          this.column.referral_partner_name = referralPartnerId
            ? this.referralPartners.find(p => Number(p.id) === Number(referralPartnerId))?.name ||
              null
            : null;
          this.tableComponent.refresh();
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: 'Account settings successfully changed',
                  type: 'success',
                },
              },
            }),
          );
        },
        error => {
          this.tableComponent.refresh();
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: error?.error || error,
                  type: 'error',
                },
              },
            }),
          );
        },
      );
  }
}
